/** A user's saved order + visibility for one design system in the workspace nav */
export class DesignSystemListViewItem {
    constructor(model) {
        this.designSystemId = model.designSystemId;
        this.sortOrder = model.sortOrder;
        this.isVisible = model.isVisible;
    }
}
